(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

  const accordions = document.querySelectorAll(".drawer-sub-accordion");

  accordions.forEach((accordion) => {

    accordion.addEventListener("toggle", function () {

      if (accordion.open) {

        accordions.forEach((item) => {

          if (item !== accordion) {
            item.removeAttribute("open");
          }

        });

      }

    });

  });

});

window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const header = document.querySelector('.ctm_header_fixed');
    const body = document.body;

    if (scrollTop > 40) {
      header.classList.add('menufixed');
      body.classList.add('header-fixed', 'cart-top');
    } else {
      header.classList.remove('menufixed');
      body.classList.remove('header-fixed', 'cart-top');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
